import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { ClassifiersTable } from '../components'

export const ClassifiersPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      title={t('classifiers.classifiers')}
      items={[{ title: t('classifiers.classifiers') }]}
    >
      <ClassifiersTable />
    </PageBreadcrumbs>
  )
}
